export const SuccessStringKeys = {
  SUCCESSFULLY_ADDED_CONFIGURATION: 'successfully_added_configuration',
  SUCCESSFULLY_ADDED_EMERGENCY_CONFIGURATION:
    'successfully_added_emergency_configuration',
  SUCCESSFULLY_ADDED_GROUP: 'successfully_added_group',
  SUCCESSFULLY_CHANGED_USERS_CONFIGURATION_TO_CONFIG:
    'successfully_changed_users_configuration_to_config',
  SUCCESSFULLY_DOWNLOADED_MY_DATA: 'successfully_downloaded_my_data',
  SUCCESSFULLY_MOVED_USER_TO_GROUP: 'successfully_moved_user_to_group',
  SUCCESSFULLY_REMOVED_CONFIGURATION: 'successfully_removed_configuration',
  SUCCESSFULLY_REMOVED_EMERGENCY_CONFIGURATION:
    'successfully_removed_emergency_configuration',
  SUCCESSFULLY_REMOVED_GROUP: 'successfully_removed_group',
  SUCCESSFULLY_REMOVED_USER_FROM_ORGANIZATION:
    'successfully_removed_user_from_organization',
  SUCCESSFULLY_UPDATED_ALWAYS_INCLUDE: 'successfully_updated_always_include',
  SUCCESSFULLY_UPDATED_CONFIGURATION: 'successfully_updated_configuration',
  SUCCESSFULLY_UPDATED_EMERGENCY_CONFIGURATION:
    'successfully_updated_emergency_configuration',
  SUCCESSFULLY_UPDATED_GROUP: 'successfully_updated_group',
  SUCCESSFULLY_UPDATED_GROUP_NAME: 'successfully_updated_group_name',
  SUCCESSFULLY_UPDATED_ORGANIZATION: 'successfully_updated_organization',
  SUCCESSFULLY_UPDATED_PROFILE: 'successfully_updated_profile',
  SUCCESSFULLY_UPDATED_USERS_CONFIGURATION:
    'successfully_updated_users_configuration',
  SUCCESSFULLY_UPDATED_USERS_EMERGENCY_CONFIGURATION:
    'successfully_updated_users_emergency_configuration',
  SUCCESSFULLY_UPDATED_USERS_ROLE_TO_ROLE:
    'successfully_updated_users_role_to_role',
  SUCCESSFULLY_UPDATED_YOUR_ORGANIZATION:
    'successfully_updated_your_organization',
  SUCCESSFULLY_UPDATED_EMAIL_LANGUAGE_PREFERENCE:
    'successfully_updated_email_language_preference',
  SUCCESSFULLY_DELETED_THE_EMERGENCY_EMAIL:
    'successfully_deleted_the_emergency_email',
  SUCCESSFULLY_ADDED_TO_EMERGENCY_CONTACTS:
    'successfully_added_to_emergency_contacts',
  SUCCESSFULLY_ADDED_RESPONDERS: 'successfully_added_responders',
  SUCCESSFULLY_REMOVED_RESPONDERS: 'successfully_removed_responders',
  SUCCESSFULLY_REMOVED_EMAIL_CONTACTS: 'successfully_removed_email_contacts',
  SUCCESSFULLY_ADDED_THE_EMERGENCY_EMAIL_CONTACT:
    'successfully_added_the_emergency_email_contact',
  DOWNGRADE_REQUEST_CREATED_SUCCESSFULLY:
    'downgrade_request_created_successfully',
  UPGRADE_REQUEST_CREATED_SUCCESSFULLY: 'upgrade_request_created_successfully',
  REQUEST_CANCELLED_SUCCESSFULLY: 'request_cancelled_successfully',
  SUCCESSFULLY_CANCELLED_JOIN_REQUEST: 'successfully_cancelled_join_request',
  CANCEL_REQUEST: 'cancel_request',
  CANCEL_REQUEST_CONFIRMATION: 'cancel_request_confirmation',
  YES: 'yes',
};

export const ErrorStringKeys = {
  FAILED_TO_ADD_CONFIGURATION: 'failed_to_add_configuration',
  FAILED_TO_ADD_EMERGENCY_CONFIGURATION:
    'failed_to_add_emergency_configuration',
  FAILED_TO_ADD_GROUP: 'failed_to_add_group',
  FAILED_TO_DELETE_PROFILE: 'failed_to_delete_profile',
  FAILED_TO_GENERATE_REPORT: 'failed_to_generate_report',
  FAILED_TO_REMOVE_CONFIGURATION: 'failed_to_remove_configuration',
  FAILED_TO_REMOVE_EMERGENCY_CONFIGURATION:
    'failed_to_remove_emergency_configuration',
  FAILED_TO_REMOVE_GROUP: 'failed_to_remove_group',
  FAILED_TO_REMOVE_USER_FROM_ORGANIZATION:
    'failed_to_remove_user_from_organization',
  FAILED_TO_RETRIEVE_EMERGENCY: 'failed_to_retrieve_emergency',
  FAILED_TO_RETRIEVE_YOUR_DATA: 'failed_to_retrieve_your_data',
  FAILED_TO_SEND_MESSAGE: 'failed_to_send_message',
  FAILED_TO_UPDATE_ALWAYS_INCLUDE: 'failed_to_update_always_include',
  FAILED_TO_UPDATE_CONFIGURATION: 'failed_to_update_configuration',
  FAILED_TO_UPDATE_EMERGENCY_CONFIGURATION:
    'failed_to_update_emergency_configuration',
  FAILED_TO_UPDATE_GROUP_NAME: 'failed_to_update_group_name',
  FAILED_TO_UPDATE_LOCATION_SHARING_FOR_X:
    'failed_to_update_location_sharing_for_x',
  FAILED_TO_UPDATE_ORGANIZATION: 'failed_to_update_organization',
  FAILED_TO_UPDATE_ORGANIZATION_SUBSCRIPTION_COUNT:
    'failed_to_update_organization_subscription_count',
  FAILED_TO_UPDATE_PROFILE: 'failed_to_update_profile',
  FAILED_TO_UPDATE_USERS_CONFIGURATION: 'failed_to_update_users_configuration',
  FAILED_TO_UPDATE_USERS_EMERGENCY_CONFIGURATION:
    'failed_to_update_users_emergency_configuration',
  FAILED_TO_UPDATE_USERS_GROUP: 'failed_to_update_users_group',
  FAILED_TO_UPDATE_USERS_ROLE: 'failed_to_update_users_role',
  FAILED_TO_UPDATE_USERS_SUBSCRIPTION: 'failed_to_update_users_subscription',
  FAILED_TO_UPDATE_USERS_TIER: 'failed_to_update_users_tier',
  FAILED_TO_LOAD_EMERGENCY_EMAILS: 'failed_to_load_emergency_emails',
  FAILED_TO_ADD_EMERGENCY_EMAIL: 'failed_to_add_emergency_email',
  FAILED_TO_ADD_EMERGENCY_EMAIL_EMAIL_ALREADY_EXISTS:
    'failed_to_add_emergency_email_email_already_exists',
  FAILED_TO_APPROVE_JOIN_REQUEST: 'failed_to_approve_join_request',
  FAILED_TO_APPROVE_JOIN_REQUESTS: 'failed_to_approve_join_requests',
  FAILED_TO_DENY_JOIN_REQUEST: 'failed_to_deny_join_request',
  FAILED_TO_DENY_JOIN_REQUESTS: 'failed_to_deny_join_requests',
  FAILED_TO_REMOVE_EMERGENCY_EMAIL: 'failed_to_remove_emergency_email',
  FAILED_TO_SEND_TEST_EMERGENCY_EMAIL: 'failed_to_send_test_emergency_email',
  FAILED_TO_UPDATE_EMAIL_LANGUAGE: 'failed_to_update_email_language',
  FAILED_TO_ADD_RESPONDERS: 'failed_to_add_responders',
  FAILED_TO_REMOVE_RESPONDERS: 'failed_to_remove_responders',
  FAILED_TO_REMOVE_EMAIL_CONTACTS_ERROR:
    'failed_to_remove_email_contacts_error',
  FAILED_TO_LOAD_EMERGENCY_CONTACTS: 'failed_to_load_emergency_contacts',
  FAILED_TO_CREATE_DOWNGRADE_REQUEST: 'failed_to_create_downgrade_request',
  FAILED_TO_CREATE_UPGRADE_REQUEST: 'failed_to_create_upgrade_request',
  INVALID_MAC_ADDRESS: 'invalid_mac_address',
  FAILED_TO_CANCEL_REQUEST: 'failed_to_cancel_request',
  FAILED_TO_CANCEL_JOIN_REQUEST: 'failed_to_cancel_join_request',
  SIGNALR_NEGOTIATE_ERROR_2000: 'signalr_negotiate_error',
  ORGANIZATION_DOES_NOT_EXIST_TRY_REFRESHING:
    'organization_does_not_exist_try_refreshing',
  USER_DOES_NOT_SEEM_TO_EXIST_TRY_REFRESHING:
    'user_does_not_seem_to_exist_try_refreshing',
};

export const StringKeys = {
  _911_CALLED: '_911_called',
  ACTION: 'action',
  ACCESS_USER_GUIDES: 'access_user_guides',
  ACTIVE_EMERGENCIES: 'active_emergencies',
  ACTIVE_TOOLTIP: 'active_tooltip',
  ACTIVE_LABEL: 'active_label',
  ACTIVE_NO_LOCATION_TOOLTIP: 'active_no_location_tooltip',
  ADAPTIVE_MODES: 'adaptive_modes',
  ADD: 'add',
  ADD_GROUP: 'add_group',
  ADD_NEW: 'add_new',
  ADD_NEW_CONFIGURATION: 'add_new_configuration',
  ADD_NEW_RESPONDER: 'add_new_responder',
  ADD_NEW_RESPONDERS: 'add_new_responders',
  ADDRESS: 'address',
  ADDRESS_CANNOT_BE_EMPTY: 'address_cannot_be_empty',
  ADMIN: 'admin',
  ADMIN_LOCATION_SHARING_WARNING: 'admin_location_sharing_warning',
  ADD_EMERGENCY_RECIPIENT_EMAILS: 'add_emergency_recipient_emails',
  ADD_EMAIL: 'add_email',
  ADMIN_WARNING: 'admin_warning',
  ADVANCED_SETTINGS: 'advanced_settings',
  AGREE_TO_TERMS_FORMAT: 'agree_to_terms',
  ALL_THE_TIME: 'all_the_time',
  ALWAYS_INCLUDED_IN_EMERGENCIES: 'always_included_in_emergencies',
  ALLOW_LOCATION_SHARING: 'allow_location_sharing',
  AMBULANCE_CALLED: 'ambulance_called',
  APPROVE: 'approve',
  APPROVE_SELECTED: 'approve_selected',
  AN_ACTIVE_SUBSCRIPTION_IS_REQUIRED_TO_USE_THE_EMERGENCY_MAP:
    'an_active_emergency_is_required_to_use_the_emergency_map',
  AN_ERROR_OCCURRED_PLEASE_REFRESH_YOUR_BROWSER:
    'an_error_occurred_please_refresh_your_browser',
  AWAITING_ADMINISTRATOR_APPROVAL: 'awaiting_administrator_approval',
  APPROVAL_DISABLE_DISCLAIMER: 'approval_disable_disclaimer',
  APPROVAL_ENABLE_DISCLAIMER: 'approval_enable_disclaimer',
  APPROVAL_REQUIREMENT_DISABLED: 'approval_requirement_disabled',
  APPROVAL_REQUIREMENT_ENABLED: 'approval_requirement_enabled',
  APPROVAL_REQUIREMENT_REQUEST_FAILED: 'approval_requirement_request_failed',
  APP_VERSION: 'app_version',
  ASSIGN_GROUP: 'assign_group',
  ASSIGN_ROLE: 'assign_role',
  ARC_FLASH: 'arc_flash',
  ARC_FLASH_DETECTION: 'arc_flash_detection',
  ARC_FLASH_DETECTION_ENABLED: 'arc_flash_detection_enabled',
  ARE_YOU_SURE_YOU_WANT_TO_DO_THIS: 'are_you_sure_you_want_to_do_this',
  ARE_YOU_SURE_YOU_WOULD_LIKE_TO_DELETE_CONFIGURATION:
    'are_you_sure_you_would_like_to_delete_configuration',
  ARE_YOU_SURE_YOU_WOULD_LIKE_TO_REMOVE_USER_FROM_ORGANIZATION:
    'are_you_sure_you_would_like_to_remove_user_from_organization',
  ARE_YOU_SURE_YOU_WANT_TO_CHANGE_THE_ROLE:
    'are_you_sure_you_want_to_change_the_role',
  ATTENTION_USERS: 'attention_users',
  AUTOMATICALLY_ADD_CONTACTS_WHO_ADDED_ME:
    'automatically_add_contacts_who_added_me',
  AUTO_ADAPT: 'auto_adapt',
  AUTO_ADAPT_APPLIES_TO_BOTH: 'auto_adapt_applies_to_both',
  AUTO_ADAPT_USER_DEFINED: 'auto_adapt_user_defined',
  AUTO_ADAPT_ONLY: 'auto_adapt_only',
  SMART_ADAPTIVE_ONLY: 'smart_adaptive_only',
  WORK_ZONE_ADAPT: 'work_zone_adapt',
  WORK_ZONE_ADAPT_ONLY: 'work_zone_adapt_only',
  AVAILABLE_WITH_SUBSCRIPTION: 'available_with_subscription',
  BATTERY: 'battery',
  BETA_ENVIRONMENT_BANNER: 'beta_environment_banner',
  BROWSER_NOT_DETECTED: 'browser_not_detected',
  BROWSER_PERMISSIONS: 'browser_permissions',
  BUBBLE_SIZE_LARGE: 'bubble_size_large',
  BUBBLE_SIZE_SMALL: 'bubble_size_small',
  BUBBLE_SIZE_USER_DEFINED: 'bubble_size_user_defined',
  CALLING_USER: 'calling_user',
  CANCEL: 'cancel',
  CHANGE_GROUP: 'change_group',
  CHANGE_ORGANIZATION: 'change_organization',
  CLEAR_ALL: 'clear_all',
  CHANGE_USERS_GROUP: 'change_users_group',
  CLICK_IN_BROWSER_TO_ALLOW_SOUND: 'click_in_browser_to_allow_sound',
  CLICK_HERE_TO_VIEW_THE_USER_MANUAL: 'click_here_to_view_the_user_manual',
  CLICK_TO_ENTER: 'click_to_enter',
  CLICK_TO_HIDE: 'click_to_hide',
  CLICK_TO_SHOW: 'click_to_show',
  CLOSE: 'close',
  COMPANY_NAME: 'company_name',
  COMPANY_NAME_CANNOT_BE_EMPTY: 'company_name_cannot_be_empty',
  COMPANY_WIDE_EMERGENCY_RESPONDERS: 'company_wide_emergency_responders',
  COMPASS_ALERT_SOUND_ENABLED: 'compass_alert_sound_enabled',
  COMPASS_ALERT_SOUND_DISABLED: 'compass_alert_sound_disabled',
  COMPASS_ALERT_SOUND_STATUS_UNAVAILABLE: 'compass_alert_sound_status_unavailable',
  COMPASS_CORE_MANAGEMENT_DESCRIPTION: 'compass_core_management_description',
  COMPASS_PRO_DEVICE: 'compass_pro_device',
  COMPASS_CONFIGURATION: 'compass_configuration',
  COMPASS_PRO_CONFIGURATION: 'compass_pro_configuration',
  COMPASS_PRO_CONFIGURATIONS: 'compass_pro_configurations',
  COMPASS_PRO_USER_GUIDE: 'compass_pro_user_guide',
  COMPASS_PRO_WEB_APP_USER_GUIDE: 'compass_pro_web_app_user_guide',
  COMPASS_DEVICE_VERSION_DESCRIPTION: 'compass_device_version_description',
  COMPLETE: 'complete',
  COMPLETED: 'completed',
  CONFIGURATION: 'configuration',
  CONFIGURATIONS: 'configurations',
  CONFIGURATION_DESCRIPTION: 'configuration_description',
  CONFIGURATION_NAME: 'configuration_name',
  CONFIGURATION_NAME_IS_REQUIRED: 'configuration_name_is_required',
  CONFIGURATION_STATUS: 'configuration_status',
  CONFIGURATION_TAB_LABEL: 'configuration_tab_label',
  CONFIGURE_GROUP: 'configure_group',
  CONFIGURE_GROUP_LOCATION_SETTINGS: 'configure_group_location_settings',
  CONFIRM: 'confirm',
  CONFIRMED: 'confirmed',
  CONFIRM_DELETE_ACCOUNT: 'confirm_delete_account',
  CONFIRM_DELETE_RESPONDERS: 'confirm_delete_responders',
  CONFIRM_REMOVAL: 'confirm_removal',
  CONNECTION_LOST_TOOLTIP: 'connection_lost_tooltip',
  CONNECTION_LOST_LABEL: 'connection_lost_label',
  COOKIE_POLICY: 'cookie_policy',
  COORDINATES: 'coordinates',
  COPY: 'copy',
  COPIED: 'copied',
  CREATE: 'create',
  CREATE_A_GROUP: 'create_a_group',
  CREATE_CONFIGURATION: 'create_configuration',
  CREATED_BY: 'created_by',
  CREATION_TIME: 'creation_time',
  CURRENT_ALERTS_VISUALIZER: 'electrical_current_alerts_visualizer',
  CURRENT_ALERTS_VISUALIZER_DESCRIPTION:
    'electrical_current_alerts_visualizer_description',
  CURRENT_GROUP: 'current_group',
  CURRENT_EMERGENCY_RECIPIENT_EMAILS: 'current_emergency_recipient_emails',
  CURRENT_SENSITIVITY: 'electrical_current_sensitivity',
  CURRENT_SENSITIVITY_SECTION_DESCRIPTION:
    'electrical_current_sensitivity_section_description',
  CUSTOM: 'custom',
  DANGEROUS_FALL: 'dangerous_fall',
  DANISH: 'danish',
  DATE: 'date',
  DATE_REQUESTED: 'date_requested',
  DAYS_AGO: 'days_ago',
  DEGREES_BEARING: 'degrees_bearing',
  DETAILS: 'details',
  DEVICE_DETAILS: 'device_details',
  DEVICE_LAST_CONNECTED: 'device_last_connected',
  DEVICE_MANAGEMENT: 'device_management',
  DEVICES: 'devices',
  DEVICE_MANAGEMENT_BLURB: 'device_management_blurb',
  DEVICE_TYPE: 'device_type',
  DELETE: 'delete',
  DELETE_ACCOUNT: 'delete_account',
  DELETE_CONFIGURATION: 'delete_configuration',
  DELETE_EMERGENCY_EMAIL: 'delete_emergency_email',
  DISABLED: 'disabled',
  DISABLE_JOIN_APPROVAL_REQUIREMENT: 'disable_join_approval_requirement',
  DISABLE_ALL: 'disable_all',
  DENY: 'deny',
  DENY_SELECTED: 'deny_selected',
  DISPATCH: 'dispatch',
  DISPATCH_WARNING: 'dispatch_warning',
  DISPLAY_ON_MAP: 'display_on_map',
  DISTANCE_TO_NEAREST_EMERGENCY: 'distance_to_nearest_emergency',
  DOCUMENTATION: 'documentation',
  DOWNLOAD: 'download',
  DOWNLOAD_MY_DATA: 'download_my_data',
  DOWNGRADE: 'downgrade',
  DOWNGRADE_TO_CORE: 'downgrade_to_core',
  EDIT: 'edit',
  EDIT_CONFIGURATION: 'edit_configuration',
  EMAIL_ADDRESSES_ADDED_IN_THIS_SECTION:
    'email_addresses_added_in_this_section',
  EDIT_NAME: 'edit_name',
  EDIT_ORGANIZATION: 'edit_organization',
  EDIT_PROFILE: 'edit_profile',
  EMAIL: 'email',
  EMAILS: 'emails',
  EMAIL_OPTIONAL: 'email_optional',
  EMERGENCY_CONFIGURATION: 'emergency_configuration',
  EMERGENCY_CONFIGURATION_TAB_LABEL: 'emergency_configuration_tab_label',
  EMERGENCY_CONTACTS: 'emergency_contacts',
  EMERGENCY_HAS_BEEN_RESOLVED: 'emergency_has_been_resolved',
  EMERGENCY_HISTORY: 'emergency_history',
  EMERGENCY_INITIATOR: 'emergency_initiator',
  EMERGENCY_LOCATION: 'emergency_location',
  EMERGENCY_MAP: 'emergency_map',
  EMERGENCY_ONLY: 'emergency_only',
  EMERGENCY_RESPONSE_TEAM: 'emergency_response_team',
  EMERGENCY_RESPONDER_MANAGEMENT: 'emergency_responder_management',
  EMERGENCY_RESPONDERS: 'emergency_responders',
  EMERGENCY_RESPONDERS_LABEL: 'emergency_responders_',
  ADD_NEW_GROUP_MEMBERS_AS_RESPONDERS: 'add_new_group_members_as_responders',
  ADD_NEW_GROUP_MEMBERS_AS_RESPONDERS_TOOLTIP:
    'add_new_group_members_as_responders_tooltip',
  ADD_NEW_ADMINS_AS_RESPONDERS: 'add_new_admins_as_responders',
  ADD_NEW_ADMINS_AS_RESPONDERS_TOOLTIP: 'add_new_admins_as_responders_tooltip',
  EMERGENCY_SERVICE_SETTINGS: 'emergency_service_settings',
  EMERGENCY_SERVICE_SETTINGS_NO_RESPOND_SUBSCRIPTION:
    'emergency_service_settings_no_respond_subscription',
  EMERGENCY_TOOLTIP: 'emergency_tooltip',
  EMERGENCY_LABEL: 'emergency_label',
  EMERGENCY_TYPE: 'emergency_type',
  ENABLE_ALL: 'enable_all',
  ENABLE_JOIN_APPROVAL_REQUIREMENT: 'enable_join_approval_requirement',
  ENABLE_ALWAYS_INCLUDED_TO_RECEIVE_ALL_EMERGENCIES_WITHIN_YOUR_ORGANIZATIONS_GROUP:
    'enable_always_included_to_recieve_all_emergencies_within_your_organizations_group',
  ENABLE_LOCATION_SHARING_FOR: 'enable_location_sharing_for',
  ENABLE_PERIMSSIONS: 'enable_permissions',
  ENABLE_PERIMSSIONS_FOR_BROWSER: 'enable_permissions_for_browser',
  ENABLED: 'enabled',
  ENABLING_PIN_WILL_ALLOW_YOU_TO_SET_A_SIX_DIGIT_PIN:
    'enabling_pin_will_allow_you_to_set_a_six_digit_pin',
  END_USER_LICENSE_AGREEMENT: 'end_user_license_agreement',
  END_USER_LICENSE_AGREEMENT_DESCRIPTION:
    'end_user_license_agreement_description',
  ENGLISH: 'english',
  ENTER: 'enter',
  ENTER_GROUP: 'enter_group',
  ENTER_PIN: 'enter_pin',
  ERROR: 'error',
  EVENT_OCCURRED_HERE: 'event_occurred_here',
  EVENT_RESOLVED: 'event_resolved',
  FALL: 'fall',
  FALL_ALERTS: 'fall_alerts',
  FALL_DETECTION: 'fall_detection',
  FALL_DETECTION_ENABLED: 'fall_detection_enabled',
  FALSE_ALARM: 'false_alarm',
  FEET: 'feet',
  FINISH: 'finish',
  FINNISH: 'finnish',
  FIRST_NAME: 'first_name',
  FIRST_ALERT: 'first_alert',
  FIRMWARE_VERSION: 'firmware_version',
  FOOT: 'foot',
  FRENCH: 'french',
  FULL_NAME: 'full_name',
  GERMAN: 'german',
  GOT_IT: 'got_it',
  GREEK: 'greek',
  GEN_1: 'gen_1',
  GEN_2: 'gen_2',
  GROUP: 'group',
  GROUP_HAS_ASSIGNED_USERS: 'group_has_assigned_users',
  GROUP_HAS_USERS_ASSIGNED_TO_IT: 'group_has_users_assigned_to_it',
  GROUP_LOCATION_SHARING: 'group_location_sharing',
  GROUP_NAME: 'group_name',
  GROUP_NAME_CANNOT_BE_EMPTY: 'Group name cannot be empty',
  GROUP_EMERGENCY_RESPONDERS: 'group_emergency_responders',
  GROUP_EMERGENCY_RESPONDERS_FALLBACK: 'group_emergency_responders_fallback',
  SUBSCRIPTIONS_USED_IN_GROUP: 'subscriptions_used_in_group',
  GROUPS: 'groups',
  GROUPS_AND_WORKERS: 'groups_and_workers',
  HEAD_IMPACT: 'head_impact',
  HEAD_IMPACT_DETECTION: 'head_impact_detection',
  HEAD_IMPACT_DETECTION_ENABLED: 'head_impact_detection_enabled',
  HELP: 'help',
  HELP_AND_SUPPORT: 'help_and_support',
  HELP_NEEDED: 'help_needed',
  HIDE_WORKER_LOCATIONS: 'hide_worker_locations',
  HIGH: 'high',
  HIGH_RANGE: 'high_range',
  HOUR_AGO: 'hour_ago',
  HOURS_AGO: 'hours_ago',
  I_AM_HERE: 'i_am_here',
  ID: 'id',
  IF_YOU_CHANGE_YOUR_ROLE: 'if_you_change_your_role',
  IF_THE_ISSUE_PERSISTS_PLEASE_CONTACT_SUPPORT:
    'if_the_issue_persists_please_contact_support',
  INACTIVE_TOOLTIP: 'inactive_tooltip',
  INACTIVE_LABEL: 'inactive_label',
  INCIDENT: 'incident',
  INITIATED_BY: 'initiated_by',
  INSIGHTS: 'insights',
  INSIGHTS_BETA_BADGE: 'insights_beta_badge',
  INSIGHTS_RANGE_YESTERDAY: 'insights_range_yesterday',
  INSIGHTS_RANGE_7_DAYS: 'insights_range_7_days',
  INSIGHTS_RANGE_30_DAYS: 'insights_range_30_days',
  INSIGHTS_RANGE_CUSTOM: 'insights_range_custom',
  INSIGHTS_CUSTOM_RANGE_START_LABEL: 'insights_custom_range_start_label',
  INSIGHTS_CUSTOM_RANGE_END_LABEL: 'insights_custom_range_end_label',
  INSIGHTS_CUSTOM_RANGE_FROM_PREFIX: 'insights_custom_range_from_prefix',
  INSIGHTS_CUSTOM_RANGE_TO_PREFIX: 'insights_custom_range_to_prefix',
  INSIGHTS_CUSTOM_RANGE_ERROR_FROM_AFTER_TO:
    'insights_custom_range_error_from_after_to',
  INSIGHTS_CUSTOM_RANGE_ERROR_TO_AFTER_YESTERDAY:
    'insights_custom_range_error_to_after_yesterday',
  INSIGHTS_CUSTOM_RANGE_ERROR_FROM_BEFORE_EARLIEST_AVAILABLE:
    'insights_custom_range_error_from_before_earliest_available',
  INSIGHTS_CUSTOM_RANGE_DATA_AVAILABLE: 'insights_custom_range_data_available',
  INSIGHTS_CUSTOM_RANGE_DATA_AVAILABILITY_UNKNOWN:
    'insights_custom_range_data_availability_unknown',
  INSIGHTS_FLEET_STATUS_SECTION_TITLE: 'insights_fleet_status_section_title',
  INSIGHTS_FLEET_STATUS_SUBCAPTION: 'insights_fleet_status_subcaption',
  INSIGHTS_FLEET_STATUS_SUBCAPTION_LEAD: 'insights_fleet_status_subcaption_lead',
  INSIGHTS_FLEET_STATUS_SUBCAPTION_DETAIL:
    'insights_fleet_status_subcaption_detail',
  INSIGHTS_SAFETY_SECTION_TITLE: 'insights_safety_section_title',
  INSIGHTS_REPORTING_COVERAGE_LABEL: 'insights_reporting_coverage_label',
  INSIGHTS_DEVICE_STATUS_SECTION_TITLE:
    'insights_device_status_section_title',
  INSIGHTS_DEVICE_STATUS_SECTION_SUBTITLE:
    'insights_device_status_section_subtitle',
  INSIGHTS_DEVICE_STATUS_LABEL_RECENTLY_ACTIVE:
    'insights_device_status_label_recently_active',
  INSIGHTS_DEVICE_STATUS_LABEL_SEEN_24H: 'insights_device_status_label_seen_24h',
  INSIGHTS_DEVICE_STATUS_LABEL_NOT_SEEN_24H:
    'insights_device_status_label_not_seen_24h',
  INSIGHTS_VERSION_DISTRIBUTION_SECTION_TITLE:
    'insights_version_distribution_section_title',
  INSIGHTS_SECTION_LOAD_ERROR: 'insights_section_load_error',
  INSIGHTS_METRIC_NOT_ENOUGH_DATA: 'insights_metric_not_enough_data',
  INSIGHTS_RECENTLY_ACTIVE_LABEL: 'insights_recently_active_label',
  INSIGHTS_RECENTLY_ACTIVE_CAPTION: 'insights_recently_active_caption',
  INSIGHTS_ACTIVE_USERS_DIALOG_TITLE: 'insights_active_users_dialog_title',
  INSIGHTS_ACTIVE_USERS_DIALOG_EMPTY: 'insights_active_users_dialog_empty',
  INSIGHTS_REPORTED_TODAY_LABEL: 'insights_reported_today_label',
  INSIGHTS_REPORTED_TODAY_CAPTION: 'insights_reported_today_caption',
  INSIGHTS_NOT_SEEN_24H_LABEL: 'insights_not_seen_24h_label',
  INSIGHTS_NOT_SEEN_24H_CAPTION: 'insights_not_seen_24h_caption',
  INSIGHTS_LOW_BATTERY_LABEL: 'insights_low_battery_label',
  INSIGHTS_LOW_BATTERY_CAPTION: 'insights_low_battery_caption',
  INSIGHTS_LOW_BATTERY_TOOLTIP: 'insights_low_battery_tooltip',
  INSIGHTS_PROTECTED_REPORTING_TIME_LABEL:
    'insights_protected_reporting_time_label',
  INSIGHTS_PROTECTED_REPORTING_TIME_TOOLTIP:
    'insights_protected_reporting_time_tooltip',
  INSIGHTS_TIME_MUTED_LABEL: 'insights_time_muted_label',
  INSIGHTS_TIME_MUTED_TOOLTIP: 'insights_time_muted_tooltip',
  INSIGHTS_REPORTING_COVERAGE_TOOLTIP: 'insights_reporting_coverage_tooltip',
  INSIGHTS_REPORTING_COVERAGE_CAPTION: 'insights_reporting_coverage_caption',
  INSIGHTS_REPORTING_COVERAGE_NOT_ENOUGH_DATA:
    'insights_reporting_coverage_not_enough_data',
  // Shared by the protected-reporting-time and time-muted cards - both ratios use the same
  // valid-reporting-time denominator, so they carry one caption string, not two.
  INSIGHTS_OF_VALID_REPORTING_TIME_CAPTION:
    'insights_of_valid_reporting_time_caption',
  INSIGHTS_TREND_TITLE_RANGE: 'insights_trend_title_range',
  INSIGHTS_TREND_HIDDEN_SINGLE_DAY: 'insights_trend_hidden_single_day',
  INSIGHTS_TREND_TITLE: 'insights_trend_title',
  INSIGHTS_TREND_EMPTY_SINGLE_DAY_TITLE: 'insights_trend_empty_single_day_title',
  INSIGHTS_TREND_EMPTY_SINGLE_DAY_BODY: 'insights_trend_empty_single_day_body',
  INSIGHTS_TREND_EMPTY_VIEW_7_DAYS: 'insights_trend_empty_view_7_days',
  INSIGHTS_TREND_EMPTY_UNRESOLVED: 'insights_trend_empty_unresolved',
  // Sign-agnostic on purpose - the delta chip's arrow icon (not this text) is what conveys
  // direction, and callers always feed this an already-absolute-valued number.
  INSIGHTS_TREND_DELTA_PTS: 'insights_trend_delta_pts',
  // Labels the secondary "most recent resolved day" stat next to the primary sum-over-sum
  // headline on the same card - must read as clearly distinct from
  // INSIGHTS_PROTECTED_REPORTING_TIME_LABEL above, since these are two different numbers.
  INSIGHTS_TREND_LATEST_LABEL: 'insights_trend_latest_label',
  INSIGHTS_DEVICE_STATUS_DONUT_TOTAL_CAPTION:
    'insights_device_status_donut_total_caption',
  INSIGHTS_DEVICE_STATUS_LEGEND_ROW: 'insights_device_status_legend_row',
  INSIGHTS_FIRMWARE_VERSION_CHART_TITLE: 'insights_firmware_version_chart_title',
  INSIGHTS_MOBILE_PLATFORM_SUMMARY: 'insights_mobile_platform_summary',
  INSIGHTS_MOBILE_VERSION_CHART_TITLE: 'insights_mobile_version_chart_title',
  INSIGHTS_VERSION_UNKNOWN_PLATFORM_FOOTNOTE:
    'insights_version_unknown_platform_footnote',
  INSIGHTS_VERSION_UP_TO_DATE: 'insights_version_up_to_date',
  INSIGHTS_VERSION_NEEDS_UPDATE: 'insights_version_needs_update',
  INSIGHTS_VERSION_UNSUPPORTED: 'insights_version_unsupported',
  INSIGHTS_VERSION_GROUP_DEVICE_COUNT: 'insights_version_group_device_count',
  INSIGHTS_FIRMWARE_BOOTLOADER_FOOTNOTE: 'insights_firmware_bootloader_footnote',
  INSIGHTS_FIRMWARE_UNKNOWN_FOOTNOTE: 'insights_firmware_unknown_footnote',
  INSIGHTS_FIRMWARE_CURRENT_VERSION_LABEL: 'insights_firmware_current_version_label',
  INSIGHTS_FIRMWARE_VIEW_DETAILS_ACTION: 'insights_firmware_view_details_action',
  INSIGHTS_FIRMWARE_DETAILS_DIALOG_TITLE: 'insights_firmware_details_dialog_title',
  INSIGHTS_FIRMWARE_DETAILS_DIALOG_SUBTITLE: 'insights_firmware_details_dialog_subtitle',
  // Dedicated legend-row copy for the summary bar's current-release (green) segment - reuses
  // the subtitle's own "on current release" phrasing directly above it, not the card's
  // percent-based "Up to date — N (P%)" wording, since this dialog's legend has always used
  // plain "Label (N)" rows (see the needs-update/bootloader/unknown section titles it already
  // reuses as their own legend labels), not a percent breakdown.
  INSIGHTS_FIRMWARE_DETAILS_CURRENT_RELEASE_LEGEND: 'insights_firmware_details_current_release_legend',
  INSIGHTS_FIRMWARE_DETAILS_NEEDS_UPDATE_SECTION_TITLE:
    'insights_firmware_details_needs_update_section_title',
  INSIGHTS_FIRMWARE_DETAILS_NEEDS_UPDATE_SECTION_SUBTITLE:
    'insights_firmware_details_needs_update_section_subtitle',
  INSIGHTS_FIRMWARE_DETAILS_BOOTLOADER_SECTION_TITLE:
    'insights_firmware_details_bootloader_section_title',
  INSIGHTS_FIRMWARE_DETAILS_BOOTLOADER_SECTION_SUBTITLE:
    'insights_firmware_details_bootloader_section_subtitle',
  INSIGHTS_FIRMWARE_DETAILS_UNKNOWN_SECTION_TITLE:
    'insights_firmware_details_unknown_section_title',
  INSIGHTS_FIRMWARE_DETAILS_UNKNOWN_SECTION_SUBTITLE:
    'insights_firmware_details_unknown_section_subtitle',
  INSIGHTS_FIRMWARE_DETAILS_COLUMN_DEVICE: 'insights_firmware_details_column_device',
  INSIGHTS_FIRMWARE_DETAILS_COLUMN_CURRENT_VERSION:
    'insights_firmware_details_column_current_version',
  INSIGHTS_FIRMWARE_DETAILS_NO_VERSION_REPORTED:
    'insights_firmware_details_no_version_reported',
  INSIGHTS_FIRMWARE_DETAILS_SHOW_MORE: 'insights_firmware_details_show_more',
  INSIGHTS_FIRMWARE_DETAILS_SHOW_LESS: 'insights_firmware_details_show_less',
  // Device-identity fallback (a device with no c_mac reported) - deliberately NOT
  // UNKNOWN_VERSION_LABEL, which is a firmware/mobile *version* fallback ("Unknown"); reusing
  // that word here would conflate "we don't know this device's firmware version" with "we
  // don't know which device this is".
  INSIGHTS_FIRMWARE_DETAILS_UNKNOWN_DEVICE_LABEL:
    'insights_firmware_details_unknown_device_label',
  INSIGHTS_FEATURE_COMPLIANCE_SECTION_TITLE:
    'insights_feature_compliance_section_title',
  INSIGHTS_FEATURE_COMPLIANCE_SUBCAPTION: 'insights_feature_compliance_subcaption',
  INSIGHTS_ARC_COMPLIANCE_LABEL: 'insights_arc_compliance_label',
  INSIGHTS_ARC_COMPLIANCE_TOOLTIP: 'insights_arc_compliance_tooltip',
  INSIGHTS_FALL_COMPLIANCE_LABEL: 'insights_fall_compliance_label',
  INSIGHTS_FALL_COMPLIANCE_TOOLTIP: 'insights_fall_compliance_tooltip',
  INSIGHTS_HEAD_COMPLIANCE_LABEL: 'insights_head_compliance_label',
  INSIGHTS_HEAD_COMPLIANCE_TOOLTIP: 'insights_head_compliance_tooltip',
  INSIGHTS_HEAD_IMPACT_NOT_APPLICABLE: 'insights_head_impact_not_applicable',
  INSIGHTS_UTILIZATION_SECTION_TITLE: 'insights_utilization_section_title',
  INSIGHTS_PROTECTED_HOURS_LABEL: 'insights_protected_hours_label',
  INSIGHTS_PROTECTED_HOURS_CAPTION: 'insights_protected_hours_caption',
  INSIGHTS_PROTECTED_HOURS_TOOLTIP: 'insights_protected_hours_tooltip',
  INSIGHTS_DEVICE_UTILIZATION_LABEL: 'insights_device_utilization_label',
  INSIGHTS_DEVICE_UTILIZATION_CAPTION: 'insights_device_utilization_caption',
  INSIGHTS_DEVICE_UTILIZATION_TOOLTIP: 'insights_device_utilization_tooltip',
  INSIGHTS_NO_TELEMETRY_14_DAYS: 'insights_no_telemetry_14_days',
  // "Pro vs. Core Devices" comparison card (UtilizationSection's 4th card,
  // CoreProComparisonCard.tsx) - distinct device counts per class, NOT a compliance
  // percentage (this card's original metric before the device-count pivot - see
  // getCoreProDeviceCounts's own header comment in InsightsDAO.ts). Renamed from
  // `INSIGHTS_CORE_PRO_COMPLIANCE_TITLE`/`_TOOLTIP` when the metric changed, rather than
  // left stale under a "compliance"-flavored key name that no longer describes what the
  // card shows. Labels below stay plain "Compass Core"/"Compass Pro", matching
  // InsightsDAO.ts's own `isCoreLabel` display strings verbatim rather than inventing
  // slightly different wording for the same two device classes - unaffected by the metric
  // change, since both counts and ratios are still bucketed by the same two class labels.
  INSIGHTS_CORE_PRO_DEVICE_COUNT_TITLE: 'insights_core_pro_device_count_title',
  INSIGHTS_CORE_PRO_DEVICE_COUNT_TOOLTIP: 'insights_core_pro_device_count_tooltip',
  INSIGHTS_COMPASS_CORE_LABEL: 'insights_compass_core_label',
  INSIGHTS_COMPASS_PRO_LABEL: 'insights_compass_pro_label',
  INSIGHTS_WORK_ZONE_ADAPT_TITLE: 'insights_work_zone_adapt_title',
  INSIGHTS_WORK_ZONE_ADAPT_BREACH_DEFINITION:
    'insights_work_zone_adapt_breach_definition',
  INSIGHTS_WORK_ZONE_ADAPT_COLUMN_TIME: 'insights_work_zone_adapt_column_time',
  // Column header is literally "User" (PRD OQ4, signed) - NOT "User name". Order:
  // Time, User, Location, Group (added 2026-09-15, M4 user-attribution feature).
  INSIGHTS_WORK_ZONE_ADAPT_COLUMN_USER: 'insights_work_zone_adapt_column_user',
  INSIGHTS_WORK_ZONE_ADAPT_COLUMN_LOCATION: 'insights_work_zone_adapt_column_location',
  INSIGHTS_WORK_ZONE_ADAPT_COLUMN_GROUP: 'insights_work_zone_adapt_column_group',
  INSIGHTS_WORK_ZONE_ADAPT_EMPTY: 'insights_work_zone_adapt_empty',
  // The one new key M4 is permitted to add (PRD D8/D10 copy freeze; plan task 30) - this
  // card has never before had to render a breach with no GPS fix, and there is no existing
  // key for that state.
  INSIGHTS_WORK_ZONE_ADAPT_NO_LOCATION: 'insights_work_zone_adapt_no_location',
  // Aria-label/title on the Location cell's Google Maps link (added 2026-09-15 - see
  // WorkZoneAdaptCard.tsx's header comment for the PRD NG7 reversal this supports).
  INSIGHTS_WORK_ZONE_ADAPT_OPEN_IN_MAPS: 'insights_work_zone_adapt_open_in_maps',
  // Two DISTINCT fallback strings for the User/Group columns (PRD OQ1, signed: two
  // strings, not one - added 2026-09-15, M4 user-attribution feature). Deliberately
  // different messages, not near-duplicates: NO_USER_RECORDED is a pipeline-coverage fact
  // (authId === '' - pre-promote history, or an identity-less sample); UNRESOLVABLE is a
  // roster/device fact (authId is real but not found in either source). Collapsing the two
  // would make it impossible to tell "history has not been swept" from "the join is
  // broken" - see workZoneBreachUserResolver.ts's own header comment.
  INSIGHTS_WORK_ZONE_ADAPT_NO_USER_RECORDED: 'insights_work_zone_adapt_no_user_recorded',
  INSIGHTS_WORK_ZONE_ADAPT_USER_UNRESOLVABLE: 'insights_work_zone_adapt_user_unresolvable',
  INSIGHTS_WORK_ZONE_ADAPT_IDENTIFYING_USER: 'insights_work_zone_adapt_identifying_user',
  // Group's OWN two fallback strings (bug fix, 2026-09-16 - see WorkZoneAdaptCard.tsx's
  // `formatBreachGroupCell` doc comment for the production incident this corrects). Before
  // this fix, an empty Group cell silently reused the two strings above - the User column's
  // own strings - so a row with no recorded user rendered "No user recorded" in BOTH the
  // User AND the Group column, a Group cell answering a question about the user. Distinct
  // from each other for the same reason the User pair is distinct (PRD OQ1): GROUP_NO_USER
  // means there was no `authId` to look a group up for at all (nothing to look up);
  // GROUP_UNRESOLVABLE means an `authId` existed but this organization's roster has no group
  // for it (the lookup ran and came up empty). Also distinct from BOTH User strings by
  // wording, not just by key name, so the rendered text itself can never be mistaken for a
  // real group name (this org has real groups named things like "Default" and "Testing" -
  // a bare "Unknown"/"None" could plausibly BE one) and never reads as identical to
  // whatever the User cell shows on the same row.
  INSIGHTS_WORK_ZONE_ADAPT_GROUP_NO_USER: 'insights_work_zone_adapt_group_no_user',
  INSIGHTS_WORK_ZONE_ADAPT_GROUP_UNRESOLVABLE: 'insights_work_zone_adapt_group_unresolvable',
  // Owner-requested 2026-09-16: collapse/expand on this card's table (override of PRD
  // D10's "no new strings" freeze, same class of amendment as the User column). English
  // wording matches firmware-details Show N more / Show less; keys stay work-zone-adapt-
  // scoped so firmware-details copy can change independently.
  INSIGHTS_WORK_ZONE_ADAPT_SHOW_MORE: 'insights_work_zone_adapt_show_more',
  INSIGHTS_WORK_ZONE_ADAPT_SHOW_LESS: 'insights_work_zone_adapt_show_less',
  IMPACT_ALERTS: 'impact_alerts',
  IMPACTED_USERS: 'impacted_users',
  ITALIAN: 'italian',
  JUST_NOW: 'just_now',
  JOIN_REQUESTS: 'join_requests',
  KILOMETER: 'kilometer',
  KILOMETERS: 'kilometers',
  LANGUAGE: 'language',
  LAST_ACCESSED: 'last_accessed',
  LAST_KNOWN_LOCATION: 'last_known_location',
  LAST_NAME: 'last_name',
  LAST_SEEN: 'last_seen',
  LAST_SEEN_AT: 'last_seen_at',
  LAST_UPDATED: 'last_updated',
  LAST_USER: 'last_user',
  LAST_USED: 'last_used',
  LAST_WORKER_OUTSIDE_ORG_BANNER_PREFIX: 'last_worker_outside_org_banner_prefix',
  LATITUDE: 'latitude',
  LEGAL_AND_COMPLIANCE: 'legal_and_compliance',
  LOADING: 'loading',
  LOCATION: 'location',
  LOCATION_NOT_AVAILABLE: 'location_not_available',
  LOCATION_PERMISSION_ISSUE_TOOLTIP: 'location_permission_issue_tooltip',
  LOCATION_PERMISSION_WARNING: 'location_permission_warning',
  LOCATIONS_SHARED_BY_YOU: 'locations_shared_by_you',
  LOCATION_SHARING: 'location_sharing',
  LOCATION_IS_SHARED_ONLY_DURING_EMERGENCY_EVENTS:
    'location_is_shared_only_during_emergency_events',
  LOCATION_SHARING_UPDATED_FOR_X: 'location_sharing_updated_for_x',
  LOCKED: 'locked',
  LONGITUDE: 'longitude',
  LOST_CONNECTIONS: 'lost_connections',
  NAME_LOST_CONNECTION: 'name_lost_connection',
  LOG_OUT: 'log_out',
  LOW: 'low',
  LOW_RANGE: 'low_range',
  MAP: 'map',
  MAC_ADDRESS: 'mac_address',
  MAC_ADDRESS_REQUEST_ALREADY_EXISTS: 'mac_address_request_already_exists',
  MAX_ALERT: 'max_alert',
  MEDIUM: 'medium',
  MEDIUM_RANGE: 'medium_range',
  MESSAGE: 'message',
  MESSAGES: 'messages',
  MESSAGE_DELETED: 'message_deleted',
  MESSAGES_SENT_BY_YOU: 'messages_sent_by_you',
  METER: 'meter',
  METERS: 'meters',
  METERS_PER_SECOND: 'meters_per_second',
  MILE: 'mile',
  MILES: 'miles',
  MINUTE_AGO: 'minute_ago',
  MINUTES_AGO: 'minutes_ago',
  MOBILE_USER: 'mobile_user',
  MOBILE_USER_WARNING: 'mobile_user_warning',
  MODIFY_SUBSCRIPTION_COUNT: 'modify_subscription_count',
  MOMENTS_AGO: 'moments_ago',
  MUTE_SOS_BUTTON: 'mute_sos_button',
  NA: 'na',
  NAME: 'name',
  NAME_NOT_SHARING_LOCATION: 'name_not_sharing_location',
  NEW_GROUP_NAME: 'new_group_name',
  NEW_FEATURE_NOTIFICATION: 'new_feature_notification',
  NEW_DOWNGRADE: 'new_downgrade',
  NEW_UPGRADE: 'new_upgrade',
  NO: 'no',
  NO_AVAILABLE_SUBSCRIPTIONS: 'no_available_subscriptions',
  NO_DEVICES_YET: 'no_devices_yet',
  NO_INTERNET_CONNECTION_PLEASE_CHECK_YOUR_CONNECTION_AND_TRY_AGAIN:
    'no_internet_connection_please_check_your_connection_and_try_again',
  NO_LOCATION: 'no_location',
  NO_LOST_CONNECTIONS: 'no_lost_connections',
  NO_MATCH: 'no_match',
  NO_MOVEMENT_DETECTED: 'no_movement_detected',
  NO_RESPONSE_TEAM_MEMBERS_ASSIGNED: 'no_response_team_members_assigned',
  NO_SELECTED_WORKERS: 'no_selected_workers',
  NO_SUBSCRIPTIONS_ARE_CURRENTLY_AVAILABLE:
    'no_subscriptions_are_currently_available',
  NOTIFICATIONS: 'notifications',
  NO_PENDING_JOIN_REQUESTS: 'no_pending_join_requests',
  NO_USERS: 'no_users',
  NO_USERS_IN_THIS_GROUP: 'no_users_in_this_group',
  NO_USERS_MATCH_YOUR_SEARCH: 'no_users_match_your_search',
  NO_EMERGENCY_RESPONDERS_CONFIGURED: 'no_emergency_responders_configured',
  NO_EMAIL_CONTACTS_CONFIGURED: 'no_email_contacts_configured',
  NO_RECIPIENT_EMAILS_ADDED_YET: 'no_recipient_emails_added_yet',
  NONE: 'none',
  NORWEGIAN: 'norwegian',
  NOT_CAPTURED: 'not_captured',
  NOT_A_MEMBER_OF_YOUR_ORGANIZATION: 'not_a_member_of_your_organization',
  NOTIFICATIONS_PERMISSION_WARNING: 'notifications_permission_warning',
  NOTIFICATION_AND_LOCATION_PERMISSION_WARNING:
    'notification_and_location_permission_warning',
  OK: 'ok',
  ON_MY_WAY: 'on_my_way',
  ONE_DAY_AGO: 'one_day_ago',
  ONE_HOUR_AGO: 'one_hour_ago',
  ONE_MINUTE_AGO: 'one_minute_ago',
  ONLINE: 'online',
  OFFLINE: 'offline',
  ONLY_DURING_EMERGENCIES: 'only_during_emergencies',
  OPERATING_SYSTEM: 'operating_system',
  ORGANIZATION: 'organization',
  ORGANIZATION_CODE: 'organization_code',
  ORGANIZATION_DETAILS: 'organization_details',
  ORGANIZATION_CURRENTLY_HAS_MORE_SUBSCRIBED_USERS_THAN_YOUR_REQUESTED_SUBSCRIPTION_COUNT:
    'organization_currently_has_more_subscribed_users_than_your_requested_subscription_count',
  ORGANIZATION_MANAGEMENT: 'organization_management',
  ORGANIZATION_MANAGEMENT_DESCRIPTION: 'organization_management_description',
  ORGANIZATION_PIN: 'organization_pin',
  ORGANIZATION_ON_FREE_TRIAL_TITLE: 'organization_on_free_trial_title',
  ORGANIZATION_ON_FREE_TRIAL_TITLE_UNTIL:
    'organization_on_free_trial_title_until',
  ORGANIZATION_ON_FREE_TRIAL_DESCRIPTION:
    'organization_on_free_trial_description',
  ORGANIZATION_ON_FREE_TRIAL_RESPOND_CAPABILITIES:
    'organization_on_free_trial_respond_capabilities',
  TRIAL_USER_RESPOND_ELEVATION_INFO: 'trial_user_respond_elevation_info',
  ORGANIZATION_SUBSCRIPTION_SEATS_ARE_FILLED:
    'organization_subscription_seats_are_filled',
  OPS_SEATS_ARE_FILLED: 'ops_seats_are_filled',
  RESPOND_SEATS_ARE_FILLED: 'respond_seats_are_filled',
  OPS_AFFECTED_USERS: 'ops_affected_users',
  RESPOND_AFFECTED_USERS: 'respond_affected_users',
  ORGANIZATION_TOTAL_SUBSCRIPTIONS: 'organization_total_subscriptions',
  ORGANIZATION_YOUR_TEAM_BASED_ON_GROUPS: 'organize_your_team_based_on_groups',
  SUBSCRIPTIONS: 'subscriptions',
  TOTAL_SUBSCRIPTIONS_AVAILABLE: 'total_subscriptions_available',
  USAGE_ACROSS_YOUR_ORGANIZATION: 'usage_across_your_organization',
  TOTAL_SUBSCRIPTIONS_TOOLTIP: 'total_subscriptions_tooltip',
  TOTAL_OPS_SUBSCRIPTIONS_TOOLTIP: 'total_ops_subscriptions_tooltip',
  TOTAL_RESPOND_SUBSCRIPTIONS_TOOLTIP: 'total_respond_subscriptions_tooltip',
  USAGE_ACROSS_ORGANIZATION_TOOLTIP: 'usage_across_organization_tooltip',
  USERS_WITH_UNPAID_ACCOUNTS: 'users_with_unpaid_accounts',
  USERS_ALLOCATED_TO_OPS_TIER: 'users_allocated_to_ops_tier',
  USERS_ALLOCATED_TO_RESPOND_TIER: 'users_allocated_to_respond_tier',
  LEARN_MORE: 'learn_more',
  PENDING: 'pending',
  PERMISSIONS: 'permissions',
  PERSONAL_DETAILS: 'personal_details',
  PERSONAL_INFORMATION: 'personal_information',
  PHASE_PHASE: 'phase_phase',
  PHASE_NEUTRAL: 'phase_neutral',
  PHONE: 'phone',
  PHONE_NUMBER: 'phone_number',
  PLEASE_ENTER_A_CONFIGURATION_NAME: 'please_enter_a_configuration_name',
  PLEASE_ENTER_A_VALID_FIRST_NAME: 'please_enter_a_valid_first_name',
  PLEASE_ENTER_A_VALID_LAST_NAME: 'please_enter_a_valid_last_name',
  PLEASE_ENTER_A_VALID_ORGANIZATION_CODE:
    'please_enter_a_valid_organization_code',
  PLEASE_ENTER_A_VALID_PHONE_NUMBER: 'please_enter_a_valid_phone_number',
  PLEASE_ENTER_A_VALID_SIX_CHARACTER_PIN:
    'please_enter_a_valid_six_character_pin',
  PLEASE_ENTER_A_VALUE_FOR_NEW_GROUP_NAME:
    'please_enter_a_value_for_new_group_name',
  PLEASE_ENTER_YOUR_FIRST_NAME: 'please_enter_your_first_name',
  PLEASE_ENTER_YOUR_LAST_NAME: 'please_enter_your_last_name',
  PLEASE_FILL_ALL_REQUIRED_FIELDS: 'please_fill_all_required_fields',
  PLEASE_PROVIDE_BOTH_NAME_AND_EMAIL: 'please_provide_both_name_and_email',
  PLEASE_PROVIDE_A_VALID_EMAIL_ADDRESS: 'please_provide_a_valid_email_address',
  PLEASE_SELECT_A_GROUP: 'please_select_a_group',
  POLISH: 'polish',
  PORTUGUESE: 'portuguese',
  PREPARING_MAP: 'preparing_map',
  PROCESSED_JOIN_REQUESTS: 'processed_join_requests',
  PRIMARY_CONTACT: 'primary_contact',
  PRIMARY_CONTACT_CANNOT_BE_EMPTY: 'primary_contact_cannot_be_empty',
  PRIVACY_POLICY: 'privacy_policy',
  PRIVACY_POLICY_DESCRIPTION: 'privacy_policy_description',
  PROCEED: 'proceed',
  PROFILE: 'profile',
  PROFILE_CREATED_BUT_SOME_SETTINGS_FAILED_TO_UPDATE:
    'profile_created_but_some_settings_failed_to_update',
  REFRESH: 'refresh',
  REMOVE_EXISTING_SUBSCRIPTIONS: 'remove_existing_subscriptions',
  READ_END_USER_LICENSE_AGREEMENT: 'read_end_user_license_agreement',
  READ_ONLY: 'read_only',
  READ_ONLY_DESCRIPTION: 'read_only_description',
  READ_PRIVACY_POLICY: 'read_privacy_policy',
  REMOVE_USER: 'remove_user',
  REMOVE_EMAIL_FROM_EMERGENCY_RECIPIENTS:
    'remove_email_from_emergency_recipients',
  REMOVE_USER_X: 'remove_user_x',
  RESPONDERS: 'responders',
  REQUESTED_AT: 'requested_at',
  REQUIRE_APPROVAL_TO_JOIN_ORGANIZATION:
    'require_approval_to_join_organization',
  REQUIRE_PIN: 'require_pin',
  REQUIRED_FOR_SIGN_UP: 'required_for_sign_up',
  REQUIRED: 'required',
  RESOLVED: 'resolved',
  WORKERS_SELECTED: 'workers_selected',
  RESPONSE_TEAM: 'response_team',
  ROLE: 'role',
  SAVE: 'save',
  SAVING: 'saving',
  ADAPTIVE_RANGE_LIMITS: 'adaptive_range_limits',
  SA_MIN_LOWEST: 'sa_min_lowest',
  SA_MAX_HIGHEST: 'sa_max_highest',
  SEND_TEST_EMAIL: 'send_test_email',
  SEARCH_USERS: 'search_users',
  SEARCH_DEVICES: 'search_devices',
  SEARCH_NAME_OR_PHONE: 'search_name_or_phone',
  SEND_AGAIN_IN_X_SECONDS: 'send_again_in_x_seconds',
  SELECT_A_GROUP: 'select_a_group',
  SELECT_A_GROUP_TO_MANAGE_EMERGENCY_RESPONSE:
    'select_a_group_to_manage_emergency_response',
  SELECT_ALL_GROUPS: 'select_all_groups',
  SELECT_ALL_IN: 'select_all_in',
  SELECT_GROUPS_TO_DISPLAY: 'select_groups_to_display',
  SENDING: 'sending',
  SEND_TEST_EMAIL_TO_CONFIRM: 'send_test_email_to_confirm',
  SERIAL_NUMBER: 'serial_number',
  SETTINGS_AND_PREFERENCES: 'settings_and_preferences',
  SETTINGS_MARKED_WITH_LOCK_ICON: 'settings_marked_with_lock_icon',
  SHOW_WORKER_LOCATIONS: 'show_worker_locations',
  SIGN_UP: 'sign_up',
  SOS: 'sos',
  SOS_BUTTON: 'sos_button',
  SOS_BUTTON_SOUND: 'sos_button_sound',
  SPANISH: 'spanish',
  SPEC_SHEET: 'spec_sheet',
  SMART_ADAPTIVE: 'smart_adaptive',
  SPEED: 'speed',
  STATUS: 'status',
  SUBMIT: 'submit',
  SUBSCRIBED: 'subscribed',
  SUBSCRIPTION: 'subscription',
  SUBSCRIPTION_STATUS: 'subscription_status',
  SUCCESS_PAGE_WILL_REFRESH_IN_COUNTDOWN:
    'success_page_will_refresh_in_countdown',
  SOMETHING_WENT_WRONG: 'something_went_wrong',
  SUCCESSFULLY_APPROVED_JOIN_REQUEST: 'successfully_approved_join_request',
  SUCCESSFULLY_APPROVED_JOIN_REQUESTS: 'successfully_approved_join_requests',
  SUCCESSFULLY_DENIED_JOIN_REQUEST: 'successfully_denied_join_request',
  SUCCESSFULLY_DENIED_JOIN_REQUESTS: 'successfully_denied_join_requests',
  SUBSCRIPTION_COUNT: 'subscription_count',
  SWEDISH: 'swedish',
  TERMS_AND_CONDITIONS: 'terms_and_conditions',
  TEST_EMAIL_SENT: 'test_email_sent',
  THE_FOLLOWING_USERS_WILL_LOSE_THEIR_SUBSCRIPTION_STATUS:
    'the_following_users_will_lose_their_subscription_status',
  THE_SAFEGUARD_EQUIPMENT_WEB_APPLICATION_IS_CURRENTLY_UNDER_MAINTENANCE:
    'the_safeguard_equipment_web_application_is_currently_under_maintenance',
  THERE_ARE_NO_CURRENT_ACTIVE_EMERGENCIES:
    'there_are_no_current_active_emergencies',
  THIS_ACTION_WILL_REMOVE_YOUR_ADMIN_ACCESS:
    'this_action_will_remove_your_admin_access',
  THIS_EMAIL: 'this_email',
  THIS_EMAIL_ALREADY_EXISTS: 'this_email_already_exists',
  THIS_MESSAGE_HAS_BEEN_DELETED: 'this_message_has_been_deleted',
  THIS_USER_HAS_NO_EMERGENCY_RESPONSE_TEAM_MEMBERS:
    'this_user_has_no_emergency_response_team_members',
  THEY_CANNOT_TURN_IT_OFF_ENTIRELY: 'they_cannot_turn_it_off_entirely',
  TIME: 'time',
  TIMESTAMP: 'timestamp',
  TO_DISPLAY_YOUR_LOCATION_ON_THE_EMERGENCY_MAP_PLEASE_ENABLE_LOCATION_PERISSIONS:
    'to_display_your_location_on_the_emergency_map_please_enable_location_permissions',
  TOOLTIP_ASSIGNED_CONFIGURATION: 'tooltip_assigned_configuration',
  TOOLTIP_ENABLING_ALWAYS_INCLUDED: 'tooltip_enabling_always_included',
  TRAINING_MATERIALS: 'training_materials',
  UNCONFIRMED: 'unconfirmed',
  UNLOCKED: 'unlocked',
  UNABLE_TO_LOAD_JOIN_REQUESTS: 'unable_to_load_join_requests',
  UNAVAILABLE_TRY_DOWNLOADING_THE_PDF_AGAIN:
    'unavailable_try_downloading_the_pdf_again',
  UPCOMING_UPDATE: 'upcoming_update',
  UPDATE_GROUP_NAME: 'update_group_name',
  UPGRADE: 'upgrade',
  UPGRADE_TO_PRO: 'upgrade_to_pro',
  UPON_CHANGING_THE_ROLE: 'upon_changing_the_role',
  USER: 'user',
  USER_DATA: 'user_data',
  USER_DEFINED: 'user_defined',
  USER_CLOSED_THE_EMERGENCY_EVENT: 'user_closed_the_emergency_event',
  USER_EXPERIENCED_A_DANGEROUS_FALL: 'user_experienced_a_dangerous_fall',
  USER_EXPERIENCED_A_DANGEROUS_HEAD_IMPACT:
    'user_experienced_a_dangerous_head_impact',
  USER_EXPERIENCED_AN_ARC_FLASH: 'user_experienced_an_arc_flash',
  USER_HAS_CALLED_911: 'user_has_called_911',
  USER_HAS_CALLED_AN_AMBULANCE: 'user_has_called_an_ambulance',
  USER_HAS_NOT_MOVED_FOR_SIXTY_SECONDS: 'user_has_not_moved_for_sixty_seconds',
  USER_HAS_REPORTED_A_DANGEROUS_FALL: 'user_has_reported_a_dangerous_fall',
  USER_HAS_REPORTED_A_SIGNIFICANT_HEAD_IMPACT:
    'user_has_reported_a_significant_head_impact',
  USER_HAS_REPORTED_AN_ARC_FLASH_INCIDENT:
    'user_has_reported_an_arc_flash_incident',
  USER_HAS_REPORTED_AN_EMERGENCY: 'user_has_reported_an_emergency',
  USER_HAS_REPORTED_AN_EMERGENCY_WITH_THE_SOS_BUTTON:
    'user_has_reported_an_emergency_with_the_sos_button',
  USER_IS_HEADING_TO_THE_EMERGENCY_EVENT:
    'user_is_heading_to_the_emergency_event',
  USER_IS_OK: 'user_is_ok',
  USER_GUIDES: 'user_guides',
  USER_GUIDES_DESCRIPTION: 'user_guides_description',
  USER_MANAGEMENT: 'user_management',
  USER_NAME: 'user_name',
  USER_NEEDS_AN_AMBULANCE: 'user_needs_an_ambulance',
  USER_NEEDS_HELP_AT_THEIR_LOCATION: 'user_needs_help_at_their_location',
  USER_ONE_IS_CALLING_USER_TWO: 'user_one_is_calling_user_two',
  USER_PRESSED_THE_SOS_BUTTON: 'user_pressed_the_sos_button',
  USER_SUBSCRIBED_TO_GROUP: 'user_subscribed_to_group',
  USER_UNSUBSCRIBED_FROM_GROUP: 'user_unsubscribed_from_group',
  USER_TIER_UPDATED: 'user_tier_updated',
  USERS: 'users',
  TIER_CONNECT: 'tier_connect',
  TIER_CONNECT_DESCRIPTION: 'tier_connect_description',
  TIER_CONNECT_INCLUDED_TITLE: 'tier_connect_included_title',
  TIER_CONNECT_INCLUDED_ITEM_1: 'tier_connect_included_item_1',
  TIER_CONNECT_INCLUDED_ITEM_2: 'tier_connect_included_item_2',
  TIER_CONNECT_INCLUDED_ITEM_3: 'tier_connect_included_item_3',
  TIER_CONNECT_INCLUDED_ITEM_4: 'tier_connect_included_item_4',
  TIER_CONNECT_INCLUDED_ITEM_5: 'tier_connect_included_item_5',
  TIER_OPS: 'tier_ops',
  TIER_OPS_DESCRIPTION: 'tier_ops_description',
  TIER_OPS_INCLUDED_TITLE: 'tier_ops_included_title',
  TIER_OPS_INCLUDED_ITEM_1: 'tier_ops_included_item_1',
  TIER_OPS_INCLUDED_ITEM_2: 'tier_ops_included_item_2',
  TIER_OPS_INCLUDED_ITEM_3: 'tier_ops_included_item_3',
  TIER_OPS_INCLUDED_ITEM_4: 'tier_ops_included_item_4',
  TIER_RESPOND: 'tier_respond',
  TIER_RESPOND_DESCRIPTION: 'tier_respond_description',
  TIER_RESPOND_INCLUDED_TITLE: 'tier_respond_included_title',
  TIER_RESPOND_INCLUDED_ITEM_1: 'tier_respond_included_item_1',
  TIER_RESPOND_INCLUDED_ITEM_2: 'tier_respond_included_item_2',
  TIER_RESPOND_INCLUDED_ITEM_3: 'tier_respond_included_item_3',
  TIER_RESPOND_INCLUDED_ITEM_4: 'tier_respond_included_item_4',
  TIER_RESPOND_INCLUDED_ITEM_5: 'tier_respond_included_item_5',
  PLAN_OPS_REQUIRED_TITLE: 'plan_ops_required_title',
  PLAN_OPS_REQUIRED_BODY: 'plan_ops_required_body',
  PLAN_RESPOND_REQUIRED_TITLE: 'plan_respond_required_title',
  PLAN_RESPOND_REQUIRED_BODY: 'plan_respond_required_body',
  MAP_REQUIRES_PAID_PLAN: 'map_requires_paid_plan',
  EMERGENCY_MAP_REQUIRES_RESPOND: 'emergency_map_requires_respond',
  CONFIG_REQUIRES_PAID_PLAN: 'config_requires_paid_plan',
  CONFIG_REQUIRES_RESPOND: 'config_requires_respond',
  VIEW_SAMPLE_CONFIGURATION: 'view_sample_configuration',
  RESPONDER_MANAGEMENT_REQUIRES_RESPOND:
    'responder_management_requires_respond',
  BASE_CONFIG_READ_ONLY: 'base_config_read_only',
  BASE_CONFIG_LOCKED_INFO: 'base_config_locked_info',
  NEW_MEMBERS_JOIN_AS_CONNECT: 'new_members_join_as_connect',
  USERS_CURRENTLY_ASSIGNED_TO_CONFIGURATION:
    'users_currently_assigned_to_configuration',
  USERS_LOCATION_HISTORY_DURING_EMERGENCY:
    'users_location_history_during_emergency',
  USERS_RESPONSE_TEAM: 'users_response_team',
  UNDEFINED: 'undefined',
  UNKNOWN: 'unknown',
  UNKNOWN_ALERT_OPTION: 'unknown_alert_option',
  UNKNOWN_DEVICE: 'unknown_device',
  VERSION: 'version',
  VIEW_ACTIVE_EMERGENCIES: 'view_active_emergencies',
  VIEW_EMERGENCY_RESPONSE_TEAM: 'view_emergency_response_team',
  VISUALIZERS: 'visualizers',
  WAIT_X_SECONDS_BEFORE_SENDING_AGAIN: 'wait_x_seconds_before_sending_again',
  VOLTAGE_ALERTS_VISUALIZER: 'voltage_alerts_visualizer',
  VOLTAGE_ALERTS_VISUALIZER_DESCRIPTION:
    'voltage_alerts_visualizer_description',
  VOLTAGE_RANGE: 'voltage_range',
  VOLTAGE_SENSITIVITY: 'voltage_sensitivity',
  VOLTAGE_SENSITIVITY_SECTION_DESCRIPTION:
    'voltage_sensitivity_section_description',
  WARNING: 'warning',
  WE_USE_NECESSARY_COOKIES_TO_PART_1: 'we_use_necessary_cookies_to_part_1',
  WE_USE_NECESSARY_COOKIES_TO_PART_2: 'we_use_necessary_cookies_to_part_2',
  WE_WILL_BE_BACK_SOON: 'we_will_be_back_soon',
  WE_WILL_BE_UPDATING_THE_SAFEGUARD_EQUIPMENT_WEB_APPLICATION:
    'we_will_be_updating_the_safeguard_equipment_web_application',
  WEB_APP_VERSION: 'web_app_version',
  WHILE_USING_APP: 'while_using_app',
  WORKERS_CAN_CHOOSE_TO_SHARE_LOCATION: 'workers_can_choose_to_share_location',
  WORKER_APP_LOCATION_SHARING_WARNING: 'worker_app_location_sharing_warning',
  WORKER_CANNOT_EDIT_SETTING: 'worker_cannot_edit_setting',
  WORK_AREA_SIZE: 'work_area_size',
  WORKER_CAN_CHOOSE_TO_ENABLE_OR_DISABLE_THIS_SETTING:
    'worker_can_choose_to_enable_or_disable_this_setting',
  WHENEVER_COMPASS_IS_CONNECTED: 'whenever_compass_is_connected',
  X_OF_Y: 'x_of_y',
  YES: 'yes',
  YOU_REQUESTED_TO_JOIN_ORGANIZATION: 'you_requested_to_join_organization',
  YOU_ARE_UNAUTHORIZED_TO_VIEW_THIS_PAGE:
    'you_are_unauthorized_to_view_this_page',
  YOUR_EMERGENCY_HISTORY_IS_EMPTY: 'your_emergency_history_is_empty',
  YOU_CAN_CHANGE_THESE_SETTINGS_IN_COMPASS_PRO_CONFIGURATIONS_PAGE:
    'you_can_change_these_settings_in_compass_pro_configurations_page',
  YOU_CAN_CHANGE_THESE_SETTINGS_IN_USER_MANAGEMENT_PAGE:
    'you_can_change_these_settings_in_user_management_page',
  YOU_MUST_BE_AN_AUTHORIZED_USER_TO_ACCESS_THIS_FEATURE:
    'you_must_be_an_authorized_user_to_access_this_feature',
  SENSITIVITY_NOT_RECOMMENDED: 'sensitivity_not_recommended',
  CURRENT_SENSITIVITY_NOT_RECOMMENDED:
    'electrical_current_sensitivity_not_recommended',
  ENABLE_SMART_ADAPTIVE_FOR_ADVANCED_SETTINGS:
    'enable_smart_adaptive_for_advanced_settings',
  ALL_USERS: 'all_users',
  X_USERS: 'x_users',
  VIEW_SUBSCRIPTIONS_BREAKDOWN: 'view_subscriptions_breakdown',
  SUBSCRIPTIONS_BREAKDOWN_BY_GROUPS: 'subscriptions_breakdown_by_groups',
  NUMBER_OF_SUBSCRIPTIONS_USED: 'number_of_subscriptions_used',
  SUBSCRIPTION_GROUPS_SCROLL: 'subscription_groups_scroll',
  SCROLL_GROUPS_LEFT: 'scroll_groups_left',
  SCROLL_GROUPS_RIGHT: 'scroll_groups_right',
  PURCHASED: 'purchased',
  USED: 'used',
  AVAILABLE: 'available',
  VIEW_AS_CHART: 'view_as_chart',
  VIEW_AS_LIST: 'view_as_list',
  BREAKDOWN_VIEW: 'breakdown_view',
  SEARCH_WORKERS_BY_NAME_ROLE_SUBSCRIPTION_PLAN:
    'search_workers_by_name_role_subscription_plan',
  GROUP_NAME_RESERVED_FOR_ALL_USERS_PAGE:
    'group_name_reserved_for_all_users_page',
};
